import {
  getCountryCode,
  getRegionList,
  getDistrictList,
  getMunicipalityList
} from './regionHelper';

let cachedRandomNum = null;

export const generateRegistrationNumber = (selections, selectedCountry, currentDateTime, userLogin) => {
  const prefix = "FN";
  const countryCode = selectedCountry?.code || "00";

  // Region code
  let regionCode = "00";
  if (selections.REGION && selections.REGION !== "--") {
    const regionName = selections.REGION.name || selections.REGION;
    const regionList = getRegionList(countryCode);
    const region = regionList?.find(r => 
      r.name.trim() === regionName.trim() || 
      r.value.toString() === regionName.trim()
    );
    if (region) {
      regionCode = region.value.toString().replace(/\D/g, '').padStart(2, '0');
    }
  }

  // District/Municipality code
  let districtCode = "000";
  if (selections.DISTRICT && selections.DISTRICT !== "--") {
    const districtName = selections.DISTRICT.name || selections.DISTRICT;
    const districtList = getDistrictList(countryCode);
    const district = districtList && districtList.find(m => 
      m.name.trim() === districtName.trim() || 
      m.value.toString() === districtName.trim()
    );
    if (district) {
      districtCode = district.value.toString().replace(/\D/g, '').padStart(3, '0');
    }
  }

  // Get user type code - handle both object and string cases
  let userTypeCode = "---";
  if (selections["USER TYPE"] && selections["USER TYPE"] !== "View more") {
    let userType = selections["USER TYPE"];
    
    // Extract the string value if it's an object
    if (typeof userType === 'object') {
      userType = userType.name || userType.value || "";
    }
    
    // Now userType should be a string, so we can safely call match()
    if (typeof userType === 'string') {
      const codeMatch = userType.match(/\(([^)]+)\)/);
      if (codeMatch && codeMatch[1]) {
        userTypeCode = codeMatch[1];
      }
    }
  }

  // SMMEs code - handle both object and string cases
  let smmesCode = "--";
  if (selections.SMMEs) {
    if (typeof selections.SMMEs === 'object' && selections.SMMEs.value) {
      smmesCode = selections.SMMEs.value;
    } else if (typeof selections.SMMEs === 'string') {
      smmesCode = selections.SMMEs;
    }
  }

  // Generate random number only once and cache it
  if (!cachedRandomNum) {
    cachedRandomNum = Math.floor(100000 + Math.random() * 900000).toString();
  }

  // Determine suffix based on selectedType (Farmer or Organization)
  let userTypeSuffix = "";
  if (selections.selectedType) {
    if (selections.selectedType.toLowerCase() === "farmer") {
      userTypeSuffix = "-I";
    } else if (selections.selectedType.toLowerCase() === "organization") {
      userTypeSuffix = "-O";
    }
  }
  // Fallback to check USER TYPE if selectedType is not available
  else if (selections["USER TYPE"]) {
    let userType = selections["USER TYPE"];
    
    // Extract the string value if it's an object
    if (typeof userType === 'object') {
      userType = userType.name || userType.value || "";
    }
    
    if (typeof userType === 'string') {
      if (userType.toLowerCase().includes("farmer") || userType.toLowerCase().includes("individual")) {
        userTypeSuffix = "-I";
      } else if (userType.toLowerCase().includes("organization") || userType.toLowerCase().includes("org")) {
        userTypeSuffix = "-O";
      }
    }
  }

  // Combine all parts with suffix
  const fullNumber = `${prefix}${countryCode}${regionCode}${districtCode}${userTypeCode}${cachedRandomNum}${userTypeSuffix}`;

  console.log("Generated registration number components:", {
    prefix,
    countryCode,
    regionCode,
    districtCode,
    userTypeCode,
    randomNum: cachedRandomNum,
    userTypeSuffix,
    fullNumber
  });

  return fullNumber;
};

export const resetCachedRandomNum = () => {
  cachedRandomNum = null;
};